import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Clients, Process, Awards, CCTVSolutions, HomeBanner } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <CCTVSolutions />
        <Services />
        <WhyUs />
        <Process />
        <HomeBanner />
        <Team />
        <Testimonials />
        <Awards />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;